import { CampaignIntegrationStatus } from "../constants";

import { CampaignJobBoardType } from "@/types/response/CampaignJobBoardType";

export type CampaignIntegrationStatusInput = Pick<
  CampaignJobBoardType,
  "isActive" | "isExpired" | "isPaused"
>;

export function getCampaignIntegrationStatus({
  isActive,
  isExpired,
  isPaused,
}: CampaignIntegrationStatusInput): CampaignIntegrationStatus {
  if (isExpired) {
    return "inactive";
  }

  if (isPaused) {
    return "paused";
  }

  return isActive ? "active" : "inactive";
}
